import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Draggable, Droppable } from '@hello-pangea/dnd';

const CustomTable = ({ columns, rows, draggable }) => {
  if (draggable) {
    return (
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer
          sx={{
            '&::-webkit-scrollbar': {
              width: 5
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#999',
              borderRadius: 2
            },
            maxHeight: '600px'
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      fontStyle: '500',
                      fontFamily: 'inherit',
                      fontSize: 14
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <Droppable droppableId="droppable">
              {(provider, snapshot) => (
                <TableBody ref={provider.innerRef} {...provider.droppableProps}>
                  {rows.map((row, i) => {
                    return (
                      <Draggable key={`row-${i}`} draggableId={`row-${i}`} index={i}>
                        {(provided) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            sx={{
                              border: `2px solid ${snapshot.isDraggingOver ? '#00998c' : 'transparent'}`
                            }}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                          >
                            {columns.map((column, j) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={`column-${j}`}
                                  align={column.align}
                                  sx={{
                                    fontFamily: 'inherit',
                                    fontSize: column.fontSize,
                                    fontWeight: column.fontWeight
                                  }}
                                >
                                  {value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        )}
                      </Draggable>
                    );
                  })}
                </TableBody>
              )}
            </Droppable>
          </Table>
        </TableContainer>
      </Paper>
    );
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer
        sx={{
          '&::-webkit-scrollbar': {
            width: 5
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#999',
            borderRadius: 2
          },
          maxHeight: '600px'
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    fontStyle: '500',
                    fontFamily: 'inherit',
                    fontSize: 14,
                    width: column?.width
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={`row-${i}`}>
                  {columns.map((column, j) => {
                    const value = row[column.id];
                    return (
                      <TableCell
                        key={`column-${j}`}
                        align={column.align}
                        sx={{
                          fontFamily: 'inherit',
                          fontSize: column.fontSize,
                          fontWeight: column.fontWeight
                        }}
                      >
                        {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CustomTable;
